import ClientAccountSetting from "../components/ClientAccountSetting/clientAccountSetting";

function ClientAccountSettingsPage () {

    return <ClientAccountSetting/>
}

export default ClientAccountSettingsPage